import ShortcutKeyComponent from './ShortcutKeyComponent';
import QueryString from './QueryString';

type QueryUpdateOptions = {
    /** @default false */
    patch?: boolean;
    /** @default false */
    replaceHistory?: boolean;
    /** @default true */
    reload?: boolean;
};

export default abstract class QueryControlComponent extends ShortcutKeyComponent {
    /** @deprecated QueryString.queryToObject(params)を使うこと */
    static queryToObject(query: string = location.search) {
        return QueryString.queryToObject(query);
    }

    /** @deprecated QueryString.objectToQuery(params)を使うこと */
    static objectToQuery(params: Record<string, string | number | null>) {
        return QueryString.objectToQuery(params);
    }

    protected queryString = QueryString.current();
    get query(): Readonly<Record<string, string | null>> {
        return this.queryString.params;
    }

    created() {
        super.created();
        const initiate = () => {
            this.queryString = QueryString.current();
            this.$forceUpdate();
            this.load();
        };

        window.addEventListener('popstate', initiate);
        initiate();
    }

    /**
     * クエリの変更タイミングに実行される
     * ・createdが呼ばれたとき
     * ・updateQueryが呼ばれたとき
     * ・ブラウザバック時
     * など
     */
    abstract load(): void;

    /**
     * @deprecated QueryString.objectToQuery(params)やthis.queryString.toString()を使うこと
     * @see QueryString
     */
    generateQuery(params: { [key: string]: string | number | null }) {
        return QueryString.objectToQuery(params);
    }

    /** @deprecated updateQueryを使うこと */
    setQuery(params: { [key: string]: string | number | null }, reload = true) {
        this.updateQuery(params, {
            patch: false,
            replaceHistory: false,
            reload,
        });
    }

    /** @deprecated patchQueryを使うこと */
    changeQuery(params: { [key: string]: string | number | null }) {
        this.patchQuery(params);
    }

    /** @deprecated updateQueryでoptionsに{ replaceHistory: true }を渡すこと */
    replaceQuery(
        params: { [key: string]: string | number | null },
        reload = false
    ) {
        this.updateQuery(params, { patch: true, replaceHistory: true, reload });
    }

    updateQuery(
        params: Record<string, string | number | null>,
        options?: QueryUpdateOptions
    ) {
        const newQuery = options?.patch
            ? this.queryString.patch(params)
            : QueryString.create(params);
        options?.replaceHistory
            ? history.replaceState(
                  newQuery.params,
                  'search',
                  newQuery.toString()
              )
            : history.pushState(newQuery.params, 'search', newQuery.toString());

        this.queryString = newQuery;
        this.$forceUpdate();

        if (options?.reload !== false) {
            window.dispatchEvent(
                new PopStateEvent('popstate', newQuery.params)
            );
        }
    }

    patchQuery(params: Record<string, string | number | null>) {
        this.updateQuery(params, {
            patch: true,
            replaceHistory: false,
            reload: true,
        });
    }
}
